export const SIGNUP_ROOT_ROUTE = 'SignUp'

export const routes = {
  contactDetails: `/${SIGNUP_ROOT_ROUTE}`,
  contactDetailsError: `/${SIGNUP_ROOT_ROUTE}/error`,
  password: `/${SIGNUP_ROOT_ROUTE}/password`,
  biometrics: `/${SIGNUP_ROOT_ROUTE}/biometrics`,
  depositLimit: `/${SIGNUP_ROOT_ROUTE}/deposit-limit`,
  depositBonus: `/${SIGNUP_ROOT_ROUTE}/deposit-bonus`,
  verification: `/${SIGNUP_ROOT_ROUTE}/verification`,
  driversLicence: `/${SIGNUP_ROOT_ROUTE}/licence`,
  passport: `/${SIGNUP_ROOT_ROUTE}/passport`,
  medicare: `/${SIGNUP_ROOT_ROUTE}/medicare`,
  failGeneral: `/${SIGNUP_ROOT_ROUTE}/fail-general`,
  verificationFailed: `/${SIGNUP_ROOT_ROUTE}/verification/failed`,
  signUpSuccess: `/${SIGNUP_ROOT_ROUTE}/success`,
  signUpUnsuccessful: `/${SIGNUP_ROOT_ROUTE}/unsuccessful`,
} as const
